import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENTS_SIGN: MijnRoute = {
    path: 'ondertekenen',
    navigationEvent: 'toOverboekenOndertekenen',
    regex: /^\/overboeken\/ondertekenen$/,
    webcomponent: 'mijn-overboeken-webcomponent',
    internalPath: '/ondertekenen'
};
